import axiosSecurity from '../axios/axiosSecurity'

export default class MenuService {
  static async get() {
    return axiosSecurity.get('menu-itens').then(res => res.data.data)
  }
}
